import React from 'react';
import CoachAvatar from './CoachAvatar';
import { COPY } from './copy';

// Three bouncing dots, each starting a little later (gb-bounce in succeedo.css).
const DOTS = [
  'animate-[gb-bounce_1.2s_ease-in-out_0s_infinite]',
  'animate-[gb-bounce_1.2s_ease-in-out_0.15s_infinite]',
  'animate-[gb-bounce_1.2s_ease-in-out_0.3s_infinite]',
];

export default function TypingIndicator({ coachName }) {
  return (
    <div className="flex items-center gap-3.5">
      <CoachAvatar name={coachName} />
      <div
        role="status"
        aria-label={COPY.thinking(coachName)}
        className="inline-flex items-center gap-[5px] bg-muted rounded-full py-[11px] px-3.5"
      >
        {DOTS.map((animation) => (
          <span key={animation} className={`w-1.5 h-1.5 rounded-full bg-muted-foreground ${animation}`} />
        ))}
      </div>
    </div>
  );
}
